import apiService from './api/ApiService';
import { t } from './i18nService';
import sessionReader from '../store/readHelpers/SessionReader';
import clientEventType from '../constants/ClientEventType';

const idleWarningService = {
    timer: undefined,
    remaining: 0,
    startTime: 0,

    getInitialValue() {
        return (window.marketplaceProperties.STUDENT_IDLE_STATE_WARNING_MINUTES || 5) * 60 * 1000;
    },

    initialize() {
        this.startTimer(true);
        this.addKeyAndClickListeners();
    },

    destroy() {
        clearTimeout(this.timer);
        clearTimeout(this.throttle);
        this.remaining = 0;
        this.removeKeyAndClickListeners();
    },

    addKeyAndClickListeners() {
        document.addEventListener('keydown', this.throttleRestartTimer.bind(this), false);
        document.addEventListener('click', this.throttleRestartTimer.bind(this), false);
    },

    removeKeyAndClickListeners() {
        document.removeEventListener('keydown', this.throttleRestartTimer.bind(this), false);
        document.removeEventListener('click', this.throttleRestartTimer.bind(this), false);
    },

    throttleRestartTimer() {
        clearTimeout(this.throttle);
        this.throttle = setTimeout(() => {
            this.restartTimer();
        }, 2000);
    },

    startTimer(fromStart) {
        if (fromStart) {
            this.remaining = idleWarningService.getInitialValue();
        }
        this.startTime = new Date().getTime();
        clearTimeout(this.timer);
        if (this.remaining < 0 || sessionReader.isPaused()) {
            return;
        }
        console.log('Start %cidle warning timer%c from %c%dms', 'font-weight: bold;', '', 'color: blue;', this.remaining);
        this.timer = setTimeout(
            this.handleIdleWarning.bind(this),
            this.remaining
        );
    },

    pauseTimer() {
        this.remaining = this.remaining - (new Date().getTime() - this.startTime);
        clearTimeout(this.throttle);
        if (this.remaining >= 0) {
            clearTimeout(this.timer);
            console.log('Pause %cidle warning timer%c at %c%dms', 'font-weight: bold;', '', 'color: blue;', this.remaining);
        }
    },

    restartTimer() {
        this.startTimer(true);
    },

    handleIdleWarning() {
        const minutes = window.marketplaceProperties?.STUDENT_IDLE_STATE_WARNING_MINUTES || 5;
        apiService.notifyClientEvent(clientEventType.IDLE, t('status.idle', { minutes }), true);
    },
};

export default idleWarningService;
